import { Text } from 'recharts'

export const CustomLabel = ({ x, y, stroke, payload }) => {
  const label = payload.value.indexOf(' ') >= 0 ? payload.value.split(' ').map(value => value + '  '.repeat(Math.abs(20 - value.length))).join('') : payload.value
  return <Text x={x} y={y} fontSize={11} breakAll width={130} letterSpacing={0} textAnchor='middle' verticalAnchor='start' height={200}>{label}</Text>
}
